<mat-sidenav-container [ngStyle]="{ 'background-color': 'transparent' }">
  <mat-sidenav
    [mode]="isSmallWindow ? 'over' : 'side'"
    [opened]="!isSmallWindow"
    [fixedInViewport]="!isSmallWindow"
    [ngStyle]="{ width: '300px' }"
    [hidden]="!(sideNav$ | async)?.show"
    [disableClose]="!isSmallWindow"
    class="mat-elevation-z1"
    [ngStyle.lt-md]="{ position: 'fixed' }"
    #sidenav
  >
    <ng-container *ngIf="group">
      <div
        [ngStyle]="{
          height: '60px',
          'background-color': (group?.background_color)[0],
          'background-size': 'cover',
          'background-position': '50% 50%',
          'background-repeat': 'no-repeat',
          'background-image':
            group?.background_image_url &&
            'url(' + group?.background_image_url + ')',
        }"
      ></div>
      <div
        [ngStyle]="{ 'background-color': (group?.background_color)[0] }"
        class="u-padding-0-32 u-padding-24-0"
      >
        <div class="text-subtitle-1" [ngStyle]="{ margin: '0' }">
          <ng-container *ngIf="userState | async as user">
            <button
              class="u-display-block c-button color-white u-width-100"
              fxLayout
              fxLayoutAlign="start center"
              (click)="showGroups = !showGroups"
              [style.color]="textColor"
            >
              <span
                [ngStyle]="{ 'max-width': 'calc(100% - 48px)' }"
                class="u-marginRight-8"
              >
                {{ group?.name }}
              </span>
              <mat-icon class="color-white" [style.color]="textColor">
                {{ showGroups ? 'arrow_drop_up' : 'arrow_drop_down' }}
              </mat-icon>
            </button>
          </ng-container>
        </div>
        <div *ngIf="!showGroups" [@menuExpansion]>
          <div
            class="u-wordWrap-breakWord u-whiteSpace-preLine u-paddingTop-16"
            [ngStyle]="{ opacity: '0.8' }"
            [style.color]="textColor"
          >
            {{ group?.content | translationLookup: ['@@groupContent'] }}
            <ng-container
              *ngIf="
                group.community_page_information?.is_visible &&
                !(
                  user.isAdmin ||
                  (user.groups | appGroupMembership: group._id)
                    ?.community_page_enabled
                )
              "
            >
              (<a
                i18n="@@groupView.aboutCommunityLink"
                class="u-textDecoration-underline"
                [routerLink]="['/hub', group.slug, 'community']"
                >About the community</a
              >)
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="u-padding-16">
      <mat-nav-list *ngIf="!showGroups" [@fadeIn]>
        <ng-container
          *ngFor="let link of links; trackBy: trackByNavigationLinkTitle"
        >
          <a
            [routerLink]="link.routerLink"
            [routerLinkActive]="['is-active']"
            class="u-display-block"
            (click)="isSmallWindow ? sidenav.close() : ''"
          >
            <mat-list-item>
              <span>{{ link.title }}</span>
              <span *ngIf="link.shouldAsterisk" class="color-teal"> * </span>
            </mat-list-item>
          </a>
          <div *ngIf="linksActive[link.title]" [@menuExpansion]>
            <ng-container *ngFor="let subState of link.subStates">
              <a
                [routerLink]="subState.routerLink"
                [routerLinkActive]="['is-active']"
                class="u-display-block"
                (click)="isSmallWindow ? sidenav.close() : ''"
              >
                <mat-list-item class="u-marginLeft-16">
                  <div fxLayout="row">
                    <p class="color-grey-300">
                      <span
                        i18n="@@groupView.navLinkSubstate"
                        >{subState.title, select, other {{{ subState.title }}}
                      }</span>
                      <span *ngIf="subState.shouldAsterisk" class="color-teal">
                        *
                      </span>
                    </p>
                    <p
                      *ngIf="subState.labelSource"
                      class="color-grey-300 u-paddingLeft-8 text-caption"
                    >
                      {{ subState.labelSource | async }}
                    </p>
                  </div>
                </mat-list-item>
              </a>
            </ng-container>
          </div>
        </ng-container>
        <div
          *ngIf="userState | async as user"
          [fxShow]="true"
          [fxShow.gt-sm]="false"
        >
          <div class="u-borderTop-grey100 u-margin-16-0"></div>
          <a
            [routerLink]="['/profile', user?.slug]"
            class="u-display-block"
            (click)="isSmallWindow ? sidenav.close() : ''"
          >
            <mat-list-item>
              {{ user.full_name }}
            </mat-list-item>
          </a>
        </div>
      </mat-nav-list>
      <mat-nav-list *ngIf="showGroups" [@fadeIn]>
        <ng-container
          *ngFor="
            let membership of (userState | async)?.groups
              | appFilterMemberships: [] : [group?._id]
              | appVisibleGroups
          "
        >
          <a
            [routerLink]="['/hub', membership?.document?.slug]"
            class="u-display-block"
          >
            <mat-list-item>
              {{ membership?.document?.name }}
            </mat-list-item>
          </a>
        </ng-container>
        <a [routerLink]="['/hubs']" class="u-display-block">
          <mat-list-item>
            <span i18n="@@groupView.findHubsLink" class="color-blue"
              >Find other Hubs</span
            >
          </mat-list-item>
        </a>
      </mat-nav-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content [ngStyle]="{ 'min-height': '100vh' }">
    <app-header-nav
      class="u-display-block bg-color-white mat-elevation-z1"
      [user]="userState | async"
      [ngStyle.gt-sm]="{
        position: 'fixed',
        top: 0,
        left: '300px',
        right: 0,
        'z-index': 100,
        transition: 'all ease-in 300ms',
      }"
      [routes]="links"
      [hasCustomDrawerAction]="true"
      (customDrawerAction)="showSideNav(sidenav)"
    >
    </app-header-nav>
    <div [ngStyle.gt-sm]="{ height: '60px' }"></div>
    <div
      *ngIf="group && 'active' !== group?.status"
      class="u-marginBottom-16 u-padding-16 u-card bg-color-orange"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="16px"
    >
      <mat-icon class="color-white"> warning</mat-icon>
      <p i18n="@@groupView.hubInactiveWarning" class="color-white">
        This Hub is inactive, which means only admins can view it.
      </p>
    </div>
    <div
      [ngStyle]="{ 'max-width': '1200px', 'margin-bottom': '80px' }"
      class="u-padding-16 u-margin-center"
    >
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
